// eslint-disable-next-line react/prop-types
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import UserRoles from '../../../constants/userRoles';
import SubHeader from '../../Header/SubHeader';
import ClientManagement from './clientManagementTab/ClientManagement';

const menuOptions = [
    {
        index: 0,
        label: 'Client Management',
    }
];

const Administration = () => {
    const navigate = useNavigate();
    const user = useSelector((state) => state.User);
    const [selectedOptionMenu, setSelectedOptionMenu] = useState('');

    const handleSelected = (choise) => {
        setSelectedOptionMenu(choise.label);
    };

    const AdministrationComponent = <ClientManagement />;
    console.log('Administration.jsx: Current User Role:', user.Role);
    if (user.Role !== UserRoles.Owner) {
        console.log('Administration.jsx: User does not have owner access.');
        return navigate(
            '/AccessDenied'
          );
    }

    return (
        <>
            <SubHeader
                handleSelected={handleSelected}
                options={menuOptions}
                selectedOptions={selectedOptionMenu}
            />
            {AdministrationComponent}
        </>
    );
};

export default Administration;
